import { AddressGet } from '../models/address-get';
import { FriendStudentGet } from '../models/friend-student-get';
import { EmailValidator } from '@angular/forms';

export class StudentGet {
  constructor() {

  }

  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name: string;
  yearOfBirth: string;
  phone: string;
  cellPhone: string;
  address: AddressGet;
  email: string;
  contactMethodId: string;
  studentLoginId: string;
  friendStudent: FriendStudentGet;
}



// WEBPACK FOOTER //
// ./src/app/models/student-get.ts